// Subtypes

export type ITableState = {
  q: string;
  hoverId: string;
};

export type ITableProviderProps = {
  data: IModel[];
  config: ITableConfig;
  onAction: OnAction;
  children: React.ReactNode;
};

export type ITableContext = {
  state: ITableState;
  config: ITableConfig;
  callbacks: {
    onAction: OnAction;
  };
  patchState: (change: Partial<ITableState>) => void;
  data: IModel[];
};

export const defaultTableState: ITableState = {
  q: '',
  hoverId: '',
};
